import React, { useState, useMemo } from 'react';
import { message } from 'antd';
import PurchaseListTemplate from '../components/PurchaseListTemplate';
import { PurchaseTabScene, PurchaseInfo } from '../../../types/process/purchase';
import { useDefaultQueryFields } from '../purchase.effect';
import PurchaseTriggerActionMap, { PurchaseTriggerActionProvider, PurchaseTriggerTarget } from '../components/PurchaseTriggerActionMap';
import purchaseApi from '../../../services/process/purchase';
import { ForgeQuery } from '../../../components/ForgeQueryBuilder';

const FinancialFinishedList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey(k => k + 1);
  const queryFields = useDefaultQueryFields(PurchaseTabScene.Finished);

  const renderTableActions = (order: PurchaseInfo) => {
    const targets: PurchaseTriggerTarget[] = ['viewOrderDetail', 'return'];
    return <PurchaseTriggerActionMap targets={targets} purchase={order} onReload={reloadList} />;
  };

  const handleExport = async (query: ForgeQuery) => {
    try {
      // 传入当前场景
      const params = { ...query, scene: PurchaseTabScene.Finished };
      await purchaseApi.export(params);
      message.success('导出任务已提交，请前往我的导出查看导出列表');
    } catch (e: any) {
      const errorMsg = e.response?.data?.message || e.message || '导出失败';
      message.error(errorMsg);
    }
  };

  return (
    <PurchaseTriggerActionProvider onReload={reloadList}>
      <PurchaseListTemplate
        title="已完结列表"
        refreshKey={refreshKey}
        queryFields={queryFields}
        tabScene={PurchaseTabScene.Finished}
        defaultScene={PurchaseTabScene.Finished}
        onExport={handleExport}
        viewModes={useMemo(() => [
          {
            mode: 'table' as const,
            label: '表格页',
            renderActions: renderTableActions,
            showField: 'tab_finished'
          }
        ], [renderTableActions])}
      />
    </PurchaseTriggerActionProvider>
  );
};

export default FinancialFinishedList;
